import { queryOptions, usePrefetchQuery, useQuery } from '@tanstack/react-query';
import { makeMaxHostsQueryOptions } from '#api/hosts.queries.ts';
import { ANY_DEVICE_OWNER_FLAG } from '#components/patterns/entity-select/device-owner/option-constants.ts';
import type { Host } from '#dn-types/host.ts';

function countHostsByUser({ data }: { data: Host[] }) {
  const counts = new Map<string, number>();
  for (const { endpointOIDCUserID } of data) {
    if (endpointOIDCUserID !== null) {
      counts.set(endpointOIDCUserID, (counts.get(endpointOIDCUserID) ?? 0) + 1);
    }
  }
  return counts;
}

/** Every host with a device owner, counted per endpoint OIDC user ID. */
const hostCountsByUserQueryOptions = queryOptions({
  ...makeMaxHostsQueryOptions({ endpointOIDCUserID: ANY_DEVICE_OWNER_FLAG }),
  select: countHostsByUser,
});

export function usePrefetchHostCountsByUser() {
  usePrefetchQuery(hostCountsByUserQueryOptions);
}

/**
 * Doesn't suspend, so a slow or failed host drain (up to ten sequential pages, or a 403 for a role that can
 * read users but not hosts) leaves the Hosts column on its count-free links instead of taking down the whole page.
 */
export function useHostCountsByUser() {
  return useQuery(hostCountsByUserQueryOptions);
}
